import { create } from "zustand";
import { api } from "../lib/api";

export const useAuth = create((set) => ({
  token: localStorage.getItem("eff_token") || null,
  user: null,
  ready: false,

  init: async () => {
    const token = localStorage.getItem("eff_token");
    if (!token) { set({ ready: true, user: null, token: null }); return; }
    try {
      const { data } = await api.get("/auth/me");
      set({ user: data, token, ready: true });
    } catch {
      localStorage.removeItem("eff_token");
      set({ user: null, token: null, ready: true });
    }
  },

  login: async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("eff_token", data.token);
    set({ token: data.token, user: data.user });
    return data;
  },

  logout: () => {
    localStorage.removeItem("eff_token");
    set({ token: null, user: null });
  },
}));
